import styled from '@emotion/styled'
import { TableContainer, TableCell, TableRow } from '@resiliatech/birdsong'
import { Box } from '@mui/material'
import { colors } from '../../../../Themes/Colors'

export const StyledTableContainer = styled(TableContainer)`
  box-shadow: none;
  border: 1px solid ${colors.lightGrey};
`

export const StyledTableCell = styled(TableCell)<{ component?: string }>`
  ${(props) =>
    props.component === 'th' &&
    `
    background-color: ${colors.lightestGrey};
    font-weight: 600;
  `}
`

export const StyledTableRow = styled(TableRow)`
  &:hover {
    background-color: ${colors.lightestBlue};
    cursor: pointer;
  }
`

export const ActionButtons = styled(Box)`
  display: flex;
  gap: 8px;
  justify-content: flex-end;
`
